import React from "react";
import clsx from "clsx";
import "./sticker-message.styles.scss";
import { $Logger } from "../../../../logger";

import type { IUIStickerMessageContent } from "../../../shared/types";
import { Sticker } from "../../Sticker";
import zCBLAnimationModule from "../../../core/engines";
import { SelectableItem } from "../../SelectableItem";
import { SnapEffectContainer } from "../../../core/animations";

export interface StickerMessageProps {
	className?: string;
	content: IUIStickerMessageContent;
}

const BlockName = "sticker-message";
const ClassNames = {
	Block: BlockName,
	Modifiers: {
		Selected: "--selected",
	},
	Elements: {
		Sticker: `${BlockName}__sticker`,
	},
} as const;

export type StickerMessageComponent = React.FC<StickerMessageProps> & {
	ClassNames: typeof ClassNames;
};

const StickerSize = 130;

export const StickerMessage = ((props: StickerMessageProps) => {
	const { content: message } = props;

	return (
		<SelectableItem selectKey={`${message.cliMsgId}`}>
			{({ attrs, isSelected }) => {
				return (
					<zCBLAnimationModule.Component.Flipped
						flipId={`msg-ct-${message.cliMsgId}`}
						// shouldFlip={() => true}
						// inverseFlipId={`cbl-i-${props.content.cliMsgId}`}
						onAppear={(element, index, decisionData, animationNG) => {
							// if (message.isLastInList) {
							element.style.opacity = "0";
							element.style.zIndex = "1000";
							animationNG?.animate(element, {
								opacity: [0, 1],
								// scale: [0.5, 1],
								translateY: [200, 0],
								duration: 300,
								easing: "ease",
							});
							console.log(
								"dongmt StickerMessage >>onAppear<<: ",
								element,
								index,
								decisionData,
							);
							// } else {
							// 	element.style.opacity = "";
							// }
						}}
						// onExit={(element, index, removeElement, decisionData, animationNG) => {
						// 	$Logger.log("dongmt onExit StickerMessage: ", message.cliMsgId);
						// 	SnapEffectContainer.EventListener.dispatchEvent(
						// 		"animate-snap",
						// 		element,
						// 	);
						// 	// removeElement();
						// }}
					>
						<div
							className={clsx(
								StickerMessage.ClassNames.Block,
								props.className,
								isSelected && StickerMessage.ClassNames.Modifiers.Selected,
							)}
							{...attrs}
						>
							<Sticker
								size={StickerSize}
								autoPlay={true}
								iterations={5}
								data={message.content}
							/>
						</div>
					</zCBLAnimationModule.Component.Flipped>
				);
			}}
		</SelectableItem>
	);
}) as StickerMessageComponent;
StickerMessage.ClassNames = ClassNames;
